var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PendingApprovalDetail',{attrs:{"request":_vm.license}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }